module.exports = __webpack_public_path__ + "img/moolah-icon-blue-lg.a9147b63.png";